var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form__item", class: _vm.fieldClasses },
    [
      _vm.label
        ? _c("tg-form-label", {
            attrs: {
              "for-name": "field-" + _vm.name,
              label: _vm.label,
              info: _vm.info,
              required: _vm.isRequired
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "input",
        _vm._b(
          {
            staticClass: "form__input",
            attrs: {
              id: "field-" + _vm.name,
              placeholder: _vm.placeholder,
              name: _vm.name,
              type: _vm.type,
              readonly: _vm.readonly,
              maxlength: _vm.maxlength
            },
            domProps: { value: _vm.value },
            on: { input: _vm.onInput, blur: _vm.onBlur }
          },
          "input",
          _vm.$attrs,
          false
        )
      ),
      _vm._v(" "),
      _vm.validation
        ? _c("tg-form-field-validation", {
            attrs: {
              validation: _vm.validationValue,
              "validation-messages": _vm.validationMessages
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.helper
        ? _c("tg-form-helper-text", { attrs: { "info-text": _vm.helper } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }